/**
 * Area and location-related hooks
 *
 * Hooks for managing user location, area detection, and area state.
 */

export { useAreaBestFit } from './useAreaBestFit';
export { useAreaFromCookie } from './useAreaFromCookie';
export { useGeolocation } from './useGeolocation';
export { useRecentAreas } from './useRecentAreas';
export { useSrpAreaData } from './useSrpAreaData';
